import { render, staticRenderFns } from "./ConsumableDetails.vue?vue&type=template&id=1ff9bb0e&scoped=true"
import script from "./ConsumableDetails.vue?vue&type=script&lang=js"
export * from "./ConsumableDetails.vue?vue&type=script&lang=js"
import style0 from "./ConsumableDetails.vue?vue&type=style&index=0&id=1ff9bb0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff9bb0e",
  null
  
)

export default component.exports